import { addEventSelectorListener, addEventMatchesListener, triggerEvent } from "../utils";

// Úložiště pro objekty reprezentující modální okna.
const modals = new WeakMap();

// *************************************************************************
// Třída.
// *************************************************************************

//
// Třída modálního okna. Proměnná "element" ukazuje na třídu s modálním oknem ".modal".
// Pokud bychom potřebovali modální okno i vytvořit, je zapotřebí
// buď ručně vystavět vhodný HTML markup a nebo si pomoci programově
// zavoláním funkce Modal.create(...).
//
export function Modal(element) {
	this.element = element;
}
Modal.prototype = {
	contructor: Modal,

	//
	// Zobrazení modálního okna.
	//
	open: function() {
		document.body.classList.add("modal-opened");
		this.element.classList.add("opened");

		triggerEvent.bind(this.element)("modal:open", { modal: this.element });
	},

	//
	// Ukončení modálního okna.
	// Modální okno po jeho zavření odstraníme.
	// Budeme podporovat zobrazení vícenásobných modálních oken, i když zatím jen takovým
	// jednoduchým způsobem.
	//
	close: function() {
		// Zavřeme modální okno.
		this.element.classList.remove("opened");

		// Zjistěme, kolik máme otevřených modálních oken.
		var openedModalsCount = document.querySelectorAll(".modal.opened").length;
		if (!openedModalsCount) {
			// Budeme zavírat poslední okno, proto můžeme zrušit speciální třídu na body elementu.
			document.body.classList.remove("modal-opened");
		}

		triggerEvent.bind(this.element)("modal:close", { modal: this.element });

		// Aby se nám nemnožily modální okna, tak (kromě těch, co jsou označeny jako "inPlace")
		// je z kódu zcela odstraňme. Většinu oken nemá smysl otevírat vícekrát, tj. jejich
		// životní cyklus typicky jejich skrytím skončí.
		if (!this.isInPlace) {
			modals.delete(this.element);
			this.element.remove();
		}
	},


	//
	// Je dané modální okno označené jako "inPlace"? In place modální okna zůstávají v kódu
	// a při jejich zavření se z kódu neodstraňují.
	//
	get isInPlace() {
		return (this.element.getAttribute("data-modal") || "").includes("inPlace");
	},

	get isNoClose() {
		return (this.element.getAttribute("data-modal") || "").includes("noClose");
	}

};

//
// Vytvoří základ modálního okna a přidá do DOM stromu. Vrací kořenový element modálního okna.
// Okno po vytvoření zůstává nezobrazené.
//
Modal.create = function() {
	var modal = document.createElement("div");
	modal.classList.add("modal");

	document.body.appendChild(modal);
	return modal;
}

//
// Instance modálního okna máme uložené ve WeakMap. Získejme instanci modálního okna pro daný element.
// Není-li element zadán, modální okno se samo vytvoří (tj. není nutné volat metodu "create").
//
Modal.get = function(element, childObject, factoryMethod) {
	if (!childObject) {
		childObject = Modal;
	}
	if (!factoryMethod) {
		factoryMethod = childObject.create;
	}
	if (!element) {
		element = factoryMethod();
	}
	element = element.closest(".modal");

	if (!modals.has(element)) {
		modals.set(element, new childObject(element));
	}

	return modals.get(element);
}


//
// Je otevřené nějaké modální okno?
//
Modal.isAnyOpened = function() {
	return 0 < document.querySelectorAll(".modal.opened").length;
}

//
// Zavření všech modálních oken najednou.
//
Modal.closeAll = function() {
	var modals = document.querySelectorAll(".modal.opened");
	for (var i = 0; i < modals.length; ++i) {
		Modal.get(modals[i]).close();
	}
}

//
// Zavření posledního modálního okna.
//
Modal.closeLast = function() {
	var modals = document.querySelectorAll(".modal.opened");
	if (0 < modals.length) {
		Modal.get(modals[modals.length - 1]).close();
	}
}



// *************************************************************************
// Události.
// *************************************************************************

//
// Otevření modálního okna, které je "in-place", tj. rovnou vloženého v kódu a nepřijde např.
// formou flash message. Narozdíl od ostatních oken se po jeho uzavření z kódu neodstraňuje.
//
addEventSelectorListener.bind(document)("click", "[href][data-modal='open']", function(event, target) {
	event.preventDefault();
	var selector = target.getAttribute("href");
	var modal = document.querySelector(selector);
	Modal.get(modal).open();
});


//
// Uzavření modálního okna kliknutím na zavírací křížek
// (křížek musí být kdekoliv v podstromě daného modálního okna, které budeme zavírat).
//
addEventSelectorListener.bind(document)("click", "[data-modal='close']", function(event, target) {
	event.preventDefault();
	Modal.get(target).close();
});


//
// Uzavření modálních oken stisknutím klávesy "escape".
// Uzavře poslední otevřené modální okno.
//
document.addEventListener("keyup", function(event) {
	if (event.key == "Escape" && Modal.isAnyOpened()) {
		event.preventDefault();
		Modal.closeLast();
	}
});


//
// Uzavření modálního okna kliknutím na černé pozadí.
//
addEventMatchesListener.bind(document)("click", ".modal.opened", function(event, target) {
	let modal = ModalDialog.get(target);
	if (!modal.isNoClose) {
		event.preventDefault();
		modal.close();
	}
});



// *************************************************************************
// Publikujeme do veřejného namespace.
// *************************************************************************
